export const counsellorHelp = [
  {
    label: "Register for the Food Bank",
    id: "Register for the Food Bank",
    value: 28,
  },
  {
    label: "Learn about New Services",
    id: "Learn about New Services",
    value: 26,
  },
  {
    label: "Electricity Bills",
    id: "Electricity Bills",
    value: 21,
  },
  {
    label: "Talk about a Problem",
    id: "Talk about a Problem",
    value: 13,
  },
  {
    label: "Deal with Finance",
    id: "Deal with Finance",
    value: 9,
  },
  {
    label: "Recieve Medical / Dental Support",
    id: "Recieve Medical / Dental Support",
    value: 1,
  },
]
